// This script come from the store one https://store.arduino.cc/js/lib/altium.js
// It's just a copy/paste without the auto initializing on page loag

/* eslint-disable */
export const altiumViewerClient = (function () {
    let e;
    function t() {
      function e(e) {
        const t = e.target,
          r = t.parentElement,
          i = { a365_domain: 'https://365.altium.com', a365_access_domains: [] };
        (i.domainOrigin = window.location.href),
          Array.prototype.slice
            .call(r.attributes)
            .filter((e) => r.hasAttribute(e.name) && 'style' != e.name)
            .forEach((e) => (i[e.name] = e.value));
        const o = { message: 'loadWidget' };
        (o.src = i), 'https:' === location.protocol ? (o.scheme = 'https') : (o.scheme = 'http'), t.contentWindow.postMessage(o, '*');
      }
      return {
        initViewer: function () {
          document.querySelectorAll('div.altium-ecad-viewer').forEach((t) => {
            const r = t.attributes.getNamedItem('data-project-src') || t.attributes.getNamedItem('project-src'),
              i = t.attributes.getNamedItem('use-border');
            if (r && r.value) {
              t.hasAttribute('data-project-src') || t.setAttribute('data-project-src', r.value);
              let o = (function (e) {
                let t = document.createElement('iframe');
                return (
                  t.setAttribute('data-src', e),
                  t.setAttribute('class', 'lazy altium-web-viewer'),
                  t.setAttribute('style', 'overflow:hidden; height:100%; width:100%; border: none;'),
                  t.setAttribute('scrolling', 'no'),
                  t.setAttribute('allowfullscreen', 'true'),
                  t.setAttribute('onload', 'window.top.scrollTo(0,0);'),
                  t
                );
              })('https://viewer.altium.com/client/index.html');
              (o.onload = e),
                (t.style.overflow = 'hidden'),
                //(t.style.maxWidth = '1280px'),
                (t.style.maxHeight = '700px'),
                (t.style.boxSizing = 'border-box'),
                t.style.height || t.style.width || ((t.style.width = '100%'), (t.style.height = '100%')),
                (i && 'false' === i.value) || ((t.style.border = '1px solid #E8E8E8'), (t.style.borderRadius = '4px')),
                t.appendChild(o);
            } else t.setAttribute('style', 'display:none; width:0; height:0; border:none;');
          }),
            yallForViewer();
        },
      };
    }
    return {
      getViewer: function () {
        return e || (e = t()), e;
      },
    };
  })(),
  eCadViewer = altiumViewerClient.getViewer();
function yallForViewer() {
  const e = {
      intersectionObserverSupport:
        'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype,
      mutationObserverSupport: 'MutationObserver' in window,
      idleCallbackSupport: 'requestIdleCallback' in window,
      eventsToBind: [
        [document, 'scroll'],
        [document, 'touchmove'],
        [window, 'resize'],
        [window, 'orientationchange'],
      ],
    },
    t = 'lazy',
    r = 'lazy-bg',
    i = 'lazy-bg-loaded',
    o = 200,
    n = !1,
    a = 200,
    s = !1,
    l = 'body',
    c = { childList: !0, subtree: !0 },
    d = `img.${t},video.${t},iframe.${t},.${r}`,
    u = { timeout: 100 },
    b = (e) => [].slice.call(e),
    m = (e) => {
      if ('IMG' === e.tagName) {
        let t = e.parentNode;
        'PICTURE' === t.tagName && b(t.querySelectorAll('source')).forEach((e) => p(e)), p(e);
      }
      'VIDEO' === e.tagName && (b(e.querySelectorAll('source')).forEach((e) => p(e)), p(e), !0 === e.autoplay && e.load()),
        'IFRAME' === e.tagName && p(e),
        e.classList.contains(r) && (e.classList.remove(r), e.classList.add(i));
    },
    p = (e) => {
      null !== e.getAttribute('data-srcset') && e.setAttribute('srcset', e.getAttribute('data-srcset')),
        null !== e.getAttribute('data-src') && e.setAttribute('src', e.getAttribute('data-src')),
        null !== e.getAttribute('data-poster') && e.setAttribute('poster', e.getAttribute('data-poster'));
    },
    w = function () {
      let r = !1;
      !1 === r &&
        h.length > 0 &&
        ((r = !0),
        setTimeout(() => {
          h.forEach((r) => {
            r.getBoundingClientRect().top <= window.innerHeight + a &&
              r.getBoundingClientRect().bottom >= -a &&
              'none' !== getComputedStyle(r).display &&
              (!0 === n && !0 === e.idleCallbackSupport
                ? requestIdleCallback(() => {
                    m(r);
                  }, u)
                : m(r),
              r.classList.remove(t),
              (h = h.filter((e) => e !== r)));
          }),
            (r = !1),
            0 === h.length && !1 === s && e.eventsToBind.forEach((e) => e[0].removeEventListener(e[1], w));
        }, o));
    };
  let h = b(document.querySelectorAll(d));
  if (!0 === e.intersectionObserverSupport) {
    var g = new IntersectionObserver(
      (r, i) => {
        r.forEach((r) => {
          if (!0 === r.isIntersecting || r.intersectionRatio > 0) {
            let o = r.target;
            !0 === n && !0 === e.idleCallbackSupport ? requestIdleCallback(() => m(o), u) : m(o),
              o.classList.remove(t),
              i.unobserve(o),
              (h = h.filter((e) => e !== o));
          }
        });
      },
      { rootMargin: `${a}px 0%` }
    );
    h.forEach((e) => g.observe(e));
  } else e.eventsToBind.forEach((e) => e[0].addEventListener(e[1], w)), w();
  !0 === e.mutationObserverSupport &&
    !0 === s &&
    new MutationObserver((t) =>
      t.forEach(() => {
        b(document.querySelectorAll(d)).forEach((t) => {
          -1 === h.indexOf(t) && (h.push(t), !0 === e.intersectionObserverSupport ? g.observe(t) : w());
        });
      })
    ).observe(document.querySelector(l), c);
}
/* eslint-enable */
